import React from 'react';
import {PolygonF} from "@react-google-maps/api";
import ClaimGuard from "../Auth/ClaimGuard";
import {GET_ALL_COMPANIES} from "../../Claims";
import ConditionalRender from "../ConditionalRender";
import useTooltip from "../../Hooks/visual/useTooltip";

const GeofencePolygon = ({ geofence, geofenceOptions, enlargedGeofenceOptions, onRegularGeofenceClick }) => {
    const {showTooltip, hideTooltip, updatePosition} = useTooltip(15);

    const onMouseMove = (e) => {
        updatePosition(e.domEvent.clientX, e.domEvent.clientY);
    };

    const onMouseOut = () => {
        hideTooltip()
    };

    const onMouseIn = () => {
        showTooltip(geofence.name)
    }


    const paths = geofence.points.map(point => ({
        lat: point.latitude,
        lng: point.longitude,
    }));

    const enlargedPaths = geofence.enlargedPoints?.map((point) => ({
        lat: point.latitude,
        lng: point.longitude,
    }));

    if (!enlargedGeofenceOptions) {
        enlargedGeofenceOptions = {
            strokeOpacity: 0.5,
            strokeWeight: 1,
            fillColor: geofenceOptions?.fillColor || "rgba(0,0,0)",
            fillOpacity: 0.3,
            zIndex: -1
        };
    }

    return (
        <>
            <PolygonF
                paths={paths}
                options={geofenceOptions}
                onClick={(e) => onRegularGeofenceClick && onRegularGeofenceClick(geofence, e)}
                onMouseMove={onMouseMove}
                onMouseOut={onMouseOut}
                onMouseOver={onMouseIn}
            />

            <ClaimGuard requiredClaim={GET_ALL_COMPANIES}>
                <ConditionalRender condition={geofence.enlargedPoints}>
                    <PolygonF paths={enlargedPaths} options={enlargedGeofenceOptions} />
                </ConditionalRender>
            </ClaimGuard>

            {/*{hoveredGeofence && createPortal(<div>{hoveredGeofence}</div>, tooltipRef.current)}*/}
        </>
    );
};

export default GeofencePolygon;